import React from "react";
import { useLocation } from "react-router-dom";
import tw from "tailwind-styled-components";

export default function ThankYouPage() {
    const location = useLocation();
    const applicationNumber = location.state?.data;

    return (
        <Container>
            <Card>
                <IconWrapper>
                    <CheckMark>✓</CheckMark>
                </IconWrapper>

                <Title>Thank You!</Title>

                <Message>
                    Your application has been submitted successfully.
                </Message>

                {applicationNumber && (
                    <div className="mt-3 mb-4 inline-flex items-center gap-2 rounded-full bg-blue-50 border border-blue-200 px-4 py-2">
                        <span className="text-sm text-gray-600">Application No.</span>
                        <span className="font-semibold text-blue-700">
                            {applicationNumber}
                        </span>
                    </div>
                )}

                <SubMessage>
                    We have received your information and will review it shortly.
                    If required, our team will contact you.
                </SubMessage>
            </Card>
        </Container>
    );
}

const Container = tw.div`
    min-h-screen
    flex
    items-center
    justify-center
    bg-gray-100
    px-4
`;

const Card = tw.div`
    w-full
    max-w-lg
    bg-white
    rounded-xl
    shadow-md
    p-10
    text-center
`;

const IconWrapper = tw.div`
    w-20
    h-20
    mx-auto
    rounded-full
    bg-green-50
    border
    border-green-200
    flex
    items-center
    justify-center
    mb-6
`;

const CheckMark = tw.span`
    text-4xl
    font-bold
    text-green-600
`;

const Title = tw.h1`
    text-3xl
    font-bold
    text-gray-800
    mb-3
`;

const Message = tw.p`
    text-lg
    text-gray-700
    mb-2
`;

const SubMessage = tw.p`
    text-sm
    text-gray-500
    leading-6
`;